/**
 * FunctionalAreaDashboardPage
 *
 * Route handler that reads the area key from ViewContext,
 * looks up the config, and renders FunctionalAreaDashboard.
 *
 * WQ-087a: Functional Area Dashboard Template
 */

import React from 'react';
import type { ViewContext } from './StubPage';
import FunctionalAreaDashboard from '../features/tenants/components/FunctionalAreaDashboard';
import { getAreaConfig, GROUP_TO_AREA_MAP } from '../features/tenants/config/functionalAreaConfigs';
import StubPage from './StubPage';

interface FunctionalAreaDashboardPageProps {
  context?: ViewContext;
}

const FunctionalAreaDashboardPage: React.FC<FunctionalAreaDashboardPageProps> = ({ context }) => {
  // The viewKey may be the area key directly (e.g., 'finance')
  // or a group ID that maps to an area key (e.g., 'hr' → 'people-culture')
  const viewKey = context?.viewKey || '';
  const areaKey = GROUP_TO_AREA_MAP[viewKey] || viewKey;
  const config = getAreaConfig(areaKey);

  if (!config) {
    return (
      <StubPage
        context={{
          viewKey: viewKey,
          navItemId: context?.navItemId || viewKey,
          groupLabel: context?.groupLabel,
          itemLabel: 'Area Not Found',
          stubMetadata: {
            title: 'Area Dashboard Not Configured',
            description: 'This functional area dashboard has not been configured yet. It will be available in a future update.',
            icon: 'layers',
          },
        }}
      />
    );
  }

  return <FunctionalAreaDashboard config={config} />;
};

export default FunctionalAreaDashboardPage;
